import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';
import statusOkIcon from '../../assets/images/statusOkIcon.svg';
import statusNotOkIcon from '../../assets/images/statusNotOkIcon.svg';
import statusWarningIcon from '../../assets/images/statusWarningIcon.svg';
import DashboardStatus, { getStatusTypeRoute } from '../../models/DashboardStatus';

import styled from './StatusCard.module.css';

//

const images: { [status: string]: string } = {
    OK: statusOkIcon,
    LOW_WARNING: statusWarningIcon,
    HIGH_WARNING: statusNotOkIcon,
};

export interface StatusCardProps {
    data: DashboardStatus[];
}

const StatusCard: FC<StatusCardProps> = ({ data }) => {
    const { user } = useAuth();
    const { t } = useTranslation();

    return (
        <div className={styled.NewsFeed}>
            <div className={styled.Header}>{user && <h4>{t('dashboardStatusTitle', { firstName: user.firstName })}</h4>}</div>

            <div className={styled.Content}>
                {data.map(status => (
                    <StatusItem key={status.statusType} status={status} />
                ))}
                {data.length == 0 && (
                    <div className={styled.EmptyContentText}>
                        <img src={statusOkIcon} alt="OK" />
                        <h4>{t('dashboardStatusTextNoWorkToDo')}</h4>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StatusCard;

interface StatusItemProps {
    status: DashboardStatus;
}

const StatusItem: FC<StatusItemProps> = ({ status }) => {
    const { user, signedInAsUser } = useAuth();
    const { t } = useTranslation();

    const signedInAs = status.statusType === 'FINISHED_REVISIONS' && signedInAsUser?.firstName;
    const pathname = getStatusTypeRoute(status.statusType);

    return (
        <div className={styled.Status} key={status.titleTextKey}>
            <img src={images[status.warningLevel]} />
            <Link to={{ pathname, state: { linkFromLandingPage: true } }}>
                <strong>{t(status.titleTextKey)}</strong>
                {signedInAs ? ` (${t('dashboardStatusSignedInAs', { signedInAs })})` : ''}:{' ' + t(status.textKey, { placeholderValue: status.placeholderValue })}
            </Link>
        </div>
    );
};
